import React, { useRef, useEffect } from 'react';
import { brandColor, getClassTextForColor } from '../../util/ColorUtil';
import { getObjectValueByMachineName } from '../../util/ObjectUtil';
import { cleanHTML } from '../utils/htmlUtils';

const CompanyLocationsInfo = ({ data, global, width, key, lang }) => {
  const items =
    data?.field_company_location_items?.title_subtitle_description_phone;
  const addressRefs = useRef([]);
  const titleRefs = useRef([]);
  const addressHeight = useRef(0);
  const titleHeight = useRef(0);

  useEffect(() => {
    addressHeight.current = Math.max(
      ...addressRefs.current.map((ref) => ref.offsetHeight)
    );
    // Set the height of all address and title elements
    addressRefs.current.forEach((ref) => {
      ref.style.height = `${addressHeight.current}px`;
    });

    titleHeight.current = Math.max(
      ...titleRefs.current.map((ref) => ref.offsetHeight)
    );
    titleRefs.current.forEach((ref) => {
      ref.style.height = `${titleHeight.current}px`;
    });
  }, [items]);

  const getLastItems = (items, itemsPerRow) => {
    if (!items || !itemsPerRow) {
      return;
    }

    const remainingItems = items?.length % itemsPerRow;
    const startIndex =
      remainingItems === 0
        ? items?.length - itemsPerRow
        : items?.length - remainingItems;
    return items?.slice(startIndex);
  };

  const calculateItemsPerRow = () => {
    if (width >= 1025) {
      return 3;
    } else if (width >= 576 && width < 1025) {
      return 2;
    } else if (width < 576) {
      return 1;
    }
  };

  const itemsPerRow = calculateItemsPerRow();

  const renderItems = () => {
    const lastItems = getLastItems(items, itemsPerRow);

    return items.map((item, index) => {
      let address = global
        ? getObjectValueByMachineName(item?.field_subtitle[0]?.value, global)
        : '';
      let phone = global
        ? getObjectValueByMachineName(item?.field_label_title[0]?.value, global)
        : '';
      let email = global
        ? getObjectValueByMachineName(item?.field_email[0]?.value, global)
        : '';

      const isLastItem = lastItems?.includes(item);
      const borderClass = !isLastItem ? 'border-bottom-true' : '';

      return (
        <div key={`company-location-${item?.field_title?.[0]?.value || index}`} className={`item ${borderClass}`}>
          <span className={'small-text'}>
            {item?.field_label_text[0]?.value}
          </span>
          <span
            className={'title'}
            ref={(ref) => (titleRefs.current[index] = ref)}
          >
            {item?.field_title[0]?.value}
          </span>
          <div
            className={'address-container'}
            ref={(ref) => (addressRefs.current[index] = ref)}
          >
            <img
              style={{
                filter:
                  getClassTextForColor(
                    data?.field_background_color[0]?.value
                  ) === 'dark'
                    ? 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(6deg) brightness(110%) contrast(98%)'
                    : 'brightness(0) saturate(100%) invert(0%) sepia(89%) saturate(7500%) hue-rotate(189deg) brightness(93%) contrast(93%)',
              }}
              src={'/images/company-location.svg'}
              alt={'location'}
            />
            <span className={'address'}>{address}</span>
          </div>
          <div
            className={`phone ${['at', 'de', 'nl', 'ch'].includes(lang) ? 'phone-de' : ''} ${['fr', 'ko'].includes(lang) ? 'phone-fr' : ''} ${lang == 'ko' ? 'phone-kr' : ''} ${lang == 'es' ? 'phone-es' : ''}`}
          >
            <label className={'phone-label'}>
              {item?.field_word[0]?.value}
            </label>
            <a
              href={'tel:' + phone}
              className={'phone-number a-company-location-link'}
            >
              {phone}
            </a>
          </div>
          <div
            className={`email ${['at', 'de', 'nl', 'ch'].includes(lang) ? 'email-de' : ''} ${['fr', 'ko'].includes(lang) ? 'email-fr' : ''} ${lang == 'ko' ? 'email-kr' : ''} ${lang == 'es' ? 'email-es' : ''}`}
          >
            <label className={'email-label'}>
              {item?.field_region_title[0]?.value}
            </label>
            <a
              href={'mailto:' + email}
              className={'email a-company-location-link'}
            >
              {email}
            </a>
          </div>
        </div>
      );
    });
  };

  return (
    <div
      key={key}
      className={
        'company-locations-info ' +
        getClassTextForColor(data?.field_background_color[0]?.value)
      }
      style={{
        backgroundColor: brandColor(data?.field_background_color[0]?.value),
      }}
    >
      <div className={'inner-container'}>
        <h2
          dangerouslySetInnerHTML={{
            __html: cleanHTML(data?.field_title_color[0]?.value),
          }}
        />
        <div className={'items'}>{renderItems()}</div>
      </div>
    </div>
  );
};

export default CompanyLocationsInfo;
